import { useMutation } from '@tanstack/react-query';
import { deleteAttachment } from '../../TimesheetsService';

const useDeleteAttachment = (options = {}) => useMutation(deleteAttachment, options);

export default useDeleteAttachment;
